import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination"


import SwiperCore, {
  Pagination
} from 'swiper';
import ImageAsync from "../../../components/native/ImageAsync";

SwiperCore.use([Pagination]);

export const RoomSlideImage = ({ images = [] }) => {
  return (

    <>
      <Swiper
        slidesPerView={'auto'}
        pagination={{
          clickable: true
        }}
        touchStartForcePreventDefault={false}
        className="sliderRoomImages"
      >

        {
          images.map((image, index) => {
            return (<SwiperSlide className="swiper-slide-badges" key={'rsld' + (index + 1)}>
              <ImageAsync className="shadow" src={image.imageUrl} alt={image.name} />
            </SwiperSlide>)
          })
        }

      </Swiper>
    </>

  );
};
